/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-spinner-action-dialog[_ngcontent-%COMP%] > .spinner[_ngcontent-%COMP%]{min-height:160px!important}@media (min-width:768px){.mat-spinner-action-dialog[_ngcontent-%COMP%]{min-width:550px!important}}"];
export { styles as styles };
